import { GridSortModel } from '@mui/x-data-grid';
import { useCallback } from 'react';

const useSortingProcessor = () => {
  const processSorting = useCallback((model: GridSortModel) => {
    const output = {};
    if (!model[0]) return output;
    const setNestedValue = (obj, keys, value) => {
      const key = keys.shift();
      if (!obj[key]) obj[key] = {};
      keys.length === 0 ? (obj[key] = value) : setNestedValue(obj[key], keys, value);
    };
    setNestedValue(output, model[0]?.field.split('.') ?? '', model[0]?.sort);
    return output;
  }, []);

  return { processSorting };
};

export default useSortingProcessor;
